import { default as MapsModule } from "./maps-module";

export default MapsModule;


// WEBPACK FOOTER //
// ./Content/scripts/modules/maps/index.ts